window.addEventListener('alpine:init', () => {
  function cartChangeLink(data = {}) {
    return {
      ...data,

      isLoadingCartChangeLink: false,

      onClick() {
        if (this.isLoadingCartChangeLink) return;

        dispatchEvent(new CustomEvent('cartchangestart'));

        this.isLoadingCartChangeLink = true;

        var url = new URL(this.$el.href);

        var id = url.searchParams.get('id') || null;

        var line = url.searchParams.get('line') || null;

        var quantity = url.searchParams.get('quantity') || null;

        var fetchUrl = url.pathname;

        var formData = new FormData();

        if (id) {
          formData.set('id', id);
        }

        if (line) {
          formData.set('line', line);
        }

        formData.set('quantity', quantity);
        formData.set('sections', this.$store.cart.sectionIds);

        var fetchOptions = {
          method: 'post',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        };

        fetch(fetchUrl, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              return res.text().then((err) => { throw new Error(err) });
            }

            return res.json();
          })
          .then((res) => {
            dispatchEvent(new CustomEvent('cartchangesuccess', { detail: { res } }));
          })
          .catch((err) => {
            dispatchEvent(new CustomEvent('cartchangeerror', { detail: { err } }));
          })
          .finally(() => {
            dispatchEvent(new CustomEvent('cartchangeend'));
            this.isLoadingCartChangeLink = false;
          });
      }
    };
  };

  Alpine.data('cartChangeLink', cartChangeLink);
});
